// useValidation.ts

import { ref, computed, Ref } from 'vue'

export interface ValidationRule<T> {
  (value: string, payload?: Partial<T>): boolean,
}

export const useValidation = <T>(
  form: Ref<T>, // The form object
  validationRules: Partial<Record<keyof T, ValidationRule<T>>> // The validation rules object
) => {
  // Validate a single field and return a boolean
  const validateField = (fieldName: keyof T, value: string): boolean => {
    const rule = validationRules[fieldName]
    if (!rule) return true
    return rule(value, form.value)
  }

  // Computed property to get invalid fields
  const invalidFields = computed(() => {
    const invalidFields = new Set<keyof T>()

    Object.keys(validationRules).forEach((fieldKey) => {
      const fieldValue = form.value[fieldKey as keyof T]
      const isValid = validateField(fieldKey as keyof T, fieldValue as unknown as string)

      if (!isValid) {
        invalidFields.add(fieldKey as keyof T)
      }
    })

    return invalidFields
  })

  return {
    validateField,
    invalidFields,
  }
}
